import React from 'react'

import { Body2, Box, Display, FlexDirection, Heading5, Space } from '@gousto-internal/citrus-react'

import { EmptySearchResults } from './EmptySearchResults'
import { MenuSearchRecipe } from './MenuSearchRecipe'
import { SearchCategoryGrid } from './SearchCategoryGrid'
import type { MenuSearchContentProps } from './types'

export const MenuSearchContent = ({
  response,
  canAddRecipes,
  reachedLimit,
  getIsInBasket,
  getQuantity,
  onAddRecipe,
  onBlockedAddAttempt,
  onCategoryClick,
  onRecipeClick,
  onRemoveRecipe,
  renderFlexPortionControl,
}: MenuSearchContentProps) => {
  const invocationId = response.type === 'search-results' ? response.invocationId : undefined
  let resultRank = 0

  const recipeProps = {
    canAddRecipes,
    reachedLimit,
    onAddRecipe,
    onBlockedAddAttempt,
    onRecipeClick,
    onRemoveRecipe,
    renderFlexPortionControl,
  }

  return (
    <Box>
      {response.content.map((block, blockIndex) => {
        const key = `${block.type}-${blockIndex}`

        if (block.type === 'search-category-grid') {
          return (
            <Box key={key} paddingBottom={4}>
              <SearchCategoryGrid contentBlock={block} onCategoryClick={onCategoryClick} />
            </Box>
          )
        }

        if (block.type === 'suggested-recipe') {
          const context = { invocationId }
          const isInBasket = getIsInBasket(block.item.id)

          return (
            <Box key={key}>
              <Heading5>{block.title}</Heading5>
              <Space size={4} />
              <MenuSearchRecipe
                {...recipeProps}
                recipe={block.item}
                context={context}
                isInBasket={isInBasket}
                quantity={getQuantity?.(block.item.id) ?? 0}
              />
            </Box>
          )
        }

        if (block.type === 'search-recipe-results') {
          return (
            <Box key={key} paddingBottom={6}>
              <Heading5>{block.title}</Heading5>
              <Body2>{block.subtitle}</Body2>
              <Space size={4} />
              <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={4}>
                {block.items.map((recipe) => {
                  const context = { invocationId, rank: resultRank++ }
                  const isInBasket = getIsInBasket(recipe.id)

                  return (
                    <MenuSearchRecipe
                      {...recipeProps}
                      key={recipe.id}
                      recipe={recipe}
                      context={context}
                      isInBasket={isInBasket}
                      quantity={getQuantity?.(recipe.id) ?? 0}
                    />
                  )
                })}
              </Box>
            </Box>
          )
        }

        if (block.type === 'empty-search-results') {
          return <EmptySearchResults key={key} title={block.title} />
        }

        return null
      })}
    </Box>
  )
}
